/* bai-fit : reduit la taille du texte quand une traduction est plus longue que l'original.
   - Header bureau : un seul facteur pour tout le header (texte, icones, logo, espaces), applique en bloc (coherence).
   - Reste du site : un facteur par role typographique (t-h2, t-h3, ..., boutons), jamais par element,
     donc deux titres de meme niveau gardent toujours la meme taille.
   - A 88 % le libelle du panier devient une icone (aria-label garde le texte).
   - L'anglais (langue de reference) n'est jamais reduit cote contenu.
   - Fiche produit (bureau) : les choix d'options restent sur une ligne, comme en francais.
   - Plancher : 80 % header, 82 % contenu. Si le plancher ne suffit pas, on garde la taille d'origine
     (le texte passe simplement a la ligne). */
(function(){
  "use strict";
  var root=document.documentElement,STEP=.02,MIN_HDR=.8,MIN_BODY=.82,HDR_MIN_W=1061;
  var ROLES=[
    {k:"display",sel:".t-display",lines:4},
    {k:"h2",sel:".t-h2",lines:3},
    {k:"h3",sel:".t-h3",lines:2},
    {k:"h4",sel:".t-h4",lines:2},
    {k:"h5",sel:".t-h5",lines:2},
    {k:"caps",sel:".t-caps",lines:2},
    {k:"btn",sel:"main .btn:not(.btn-icon), main .tab, main [role=tab]",lines:1}
  ];
  var hdr=document.querySelector(".bai-hdr"),
      row=hdr&&hdr.querySelector(".hdr-row"),
      nav=row&&row.querySelector(".hdr-nav"),
      acts=row&&row.querySelector(".hdr-actions"),
      lang=row&&row.querySelector(".hdr-lang");

  function visible(el){return el.offsetWidth>0&&el.offsetHeight>0}

  function lines(el,cs){
    var lh=parseFloat(cs.lineHeight);if(isNaN(lh))lh=parseFloat(cs.fontSize)*1.3;
    var h=el.clientHeight-parseFloat(cs.paddingTop)-parseFloat(cs.paddingBottom);
    return Math.round(h/lh);
  }
  function scrolls(el){
    for(var p=el.parentElement;p&&p!==document.body;p=p.parentElement){
      var o=getComputedStyle(p).overflowX;if(o==="auto"||o==="scroll")return true;
    }
    return false;
  }
  function fails(el,max){
    if(!visible(el))return false;
    var cs=getComputedStyle(el);
    if(cs.display==="inline")return false;
    if(el.scrollWidth>el.clientWidth+1)return true;
    if(lines(el,cs)>max)return true;
    var r=el.getBoundingClientRect(),pr=el.parentElement&&el.parentElement.getBoundingClientRect();
    if(pr&&!scrolls(el)&&(r.right>pr.right+1||r.left<pr.left-1)&&pr.width>0)return true;
    return false;
  }

  /* ---------- contenu : un facteur par role ---------- */
  function fitRoles(){
    ROLES.forEach(function(ro){root.style.removeProperty("--fit-"+ro.k)});
    if(/^en(-|$)/i.test(root.lang))return; /* l'anglais est la reference : on n'y touche pas */
    ROLES.forEach(function(ro){
      var els=Array.prototype.slice.call(document.querySelectorAll(ro.sel));
      if(!els.some(visible))return;
      var bad=function(){return els.some(function(e){return fails(e,ro.lines)})};
      if(!bad())return;
      for(var s=1-STEP;s>=MIN_BODY-1e-9;s-=STEP){
        root.style.setProperty("--fit-"+ro.k,s.toFixed(2));
        if(!bad())return;
      }
      root.style.removeProperty("--fit-"+ro.k);
    });
  }

  /* ---------- header bureau : un facteur pour tout le header ---------- */
  var hdrItems=null,saved=new Map();
  /* put/restore : on memorise la valeur d'origine (style en ligne du theme compris) avant de la changer */
  function put(el,prop,val){var m=saved.get(el);if(!m){m={};saved.set(el,m)}if(!(prop in m))m[prop]=el.style.getPropertyValue(prop);el.style.setProperty(prop,val)}
  function restore(){saved.forEach(function(m,el){for(var p in m){m[p]===""?el.style.removeProperty(p):el.style.setProperty(p,m[p])}});saved.clear()}
  function hdrCollect(){
    if(!row)return [];
    var sel=[".hdr-nav>button",".hdr-nav>.nav-link",".hdr-actions .btn:not(.btn-icon)",".hdr-lang>.btn"];
    return Array.prototype.slice.call(row.querySelectorAll(sel.join(","))).filter(function(e){return !e.closest(".tiroir-g")&&!e.classList.contains("tiroir-cta")});
  }
  function hdrReset(){
    if(!row)return;
    hdrItems=hdrItems||hdrCollect();
    restore();
    var ct=row.querySelector("[data-bai-cart] .panier-txt");
    if(ct){var ca=ct.closest("[data-bai-cart]");ca.hasAttribute("data-fit-aria")&&(ca.removeAttribute("aria-label"),ca.removeAttribute("data-fit-aria"))}
    hdr.removeAttribute("data-fit");
  }
  function hdrOk(){
    if(row.scrollWidth>row.clientWidth+1)return false;
    if(nav&&nav.scrollWidth>nav.clientWidth+1)return false;
    var last=null;
    if(nav)for(var k=nav.children.length-1;k>=0;k--){if(visible(nav.children[k])){last=nav.children[k];break}}
    if(last){
      var lr=last.getBoundingClientRect().right,stop=1/0;
      [acts,lang].forEach(function(e){if(e&&visible(e))stop=Math.min(stop,e.getBoundingClientRect().left)});
      if(lr>stop-2)return false;
    }
    return true;
  }
  function fitHeader(){
    if(!row)return;
    hdrReset();
    if(window.innerWidth<HDR_MIN_W||getComputedStyle(row.querySelector(".hdr-nav")).display==="none")return;
    if(hdrOk())return;
    var base=hdrItems.map(function(e){var c=getComputedStyle(e);return{e:e,fs:parseFloat(c.fontSize),pl:parseFloat(c.paddingLeft),pr:parseFloat(c.paddingRight)}});
    var icons=Array.prototype.slice.call(row.querySelectorAll(".hdr-nav>button svg")).map(function(v){return{e:v,w:v.getBoundingClientRect().width}}),
        logo=row.querySelector(".hdr-logo img"),logoH=logo?logo.getBoundingClientRect().height:0;
    var g=[nav,acts].map(function(e){return e?parseFloat(getComputedStyle(e).gap)||0:0}),rg=parseFloat(getComputedStyle(row).columnGap)||0;
    var cartTxt=row.querySelector("[data-bai-cart] .panier-txt"),cartHid=false;
    for(var s=1-STEP;s>=MIN_HDR-1e-9;s-=STEP){
      /* a 88 % le libelle du panier passe en icone + compteur : on garde un texte lisible (>= 14 px) */
      if(!cartHid&&cartTxt&&s<=.88+1e-9){
        var ca=cartTxt.closest("[data-bai-cart]");
        if(!ca.hasAttribute("aria-label")){ca.setAttribute("aria-label",cartTxt.textContent.trim());ca.setAttribute("data-fit-aria","")}
        put(cartTxt,"display","none");cartHid=true;
      }
      base.forEach(function(b){put(b.e,"font-size",(b.fs*s)+"px");put(b.e,"padding-left",(b.pl*s)+"px");put(b.e,"padding-right",(b.pr*s)+"px")});
      icons.forEach(function(i){put(i.e,"width",(i.w*s)+"px");put(i.e,"height",(i.w*s)+"px")});
      if(logo)put(logo,"height",(logoH*s)+"px");
      if(nav)put(nav,"gap",(g[0]*s)+"px");if(acts)put(acts,"gap",(g[1]*s)+"px");put(row,"gap",(rg*s)+"px");
      if(hdrOk()){hdr.setAttribute("data-fit",s.toFixed(2));return}
    }
    hdr.setAttribute("data-fit","min");
  }


  /* ---------- choix d'options de la fiche produit (bureau) : tous sur une ligne, comme en francais ---------- */
  function optsWrapped(g){
    var k=Array.prototype.slice.call(g.children).filter(visible);
    if(!k.length)return false;
    var top=Math.round(k[0].getBoundingClientRect().top);
    return k.some(function(c){return Math.round(c.getBoundingClientRect().top)!==top||c.offsetHeight>64});
  }
  function fitOptions(){
    var spans=Array.prototype.slice.call(document.querySelectorAll(".fi-opt-v span")),
        gs=Array.prototype.slice.call(document.querySelectorAll(".fi-opt-vals"));
    spans.forEach(function(e){e.style.fontSize="";e.style.paddingLeft="";e.style.paddingRight=""});
    if(window.innerWidth<=900||!gs.length||!gs.some(optsWrapped))return;
    var base=spans.map(function(e){var c=getComputedStyle(e);return{e:e,fs:parseFloat(c.fontSize),pl:parseFloat(c.paddingLeft),pr:parseFloat(c.paddingRight)}});
    for(var s=1-STEP;s>=MIN_BODY-1e-9;s-=STEP){
      base.forEach(function(b){b.e.style.fontSize=(b.fs*s)+"px";b.e.style.paddingLeft=(b.pl*s)+"px";b.e.style.paddingRight=(b.pr*s)+"px"});
      if(!gs.some(optsWrapped))return;
    }
    spans.forEach(function(e){e.style.fontSize="";e.style.paddingLeft="";e.style.paddingRight=""});
  }

  var t=null;
  function run(){
    clearTimeout(t);
    t=setTimeout(function(){fitHeader();fitRoles();fitOptions()},40);
  }
  window.addEventListener("resize",run);
  window.addEventListener("load",run);
  document.addEventListener("click",function(e){if(e.target.closest&&e.target.closest(".bai-hdr,[role=tab],summary"))run()});
  document.addEventListener("change",function(e){if(e.target.closest&&e.target.closest(".fi-opt"))run()});
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(run);
  run();
})();
